<template>
  <section style="width: 100%;">
    <el-card shadow="hover" style="height: 100%">
      <el-steps :active="active" finish-status="success" ref="eleSteps" :direction="direction"
                :space="space">
        <el-step v-for="(p,i) in params" :title="p.title" :flag="p.flag"
                 :description="p.description"></el-step>
      </el-steps>
    </el-card>
  </section>
</template>

<script>
  export default {
    name: "eleStep",
    props: {
      componentData: {
        type: String
      },
      showFlag: {
        type: Array
      },
    },
    data() {
      return {
        active: 0,
        space: '',
        direction: "",
        params: [],
      };
    },
    watch: {
      showFlag: {
        handler(n, o) {
          this.active = Number(n[0]);
        }
      }
    },
    mounted() {
      if (this.componentData) {
        let componentData = JSON.parse(this.componentData);
        if (componentData) {
          if (componentData.space) {
            this.space = componentData.space + "px";
          }
          this.active = parseInt(componentData.active);
          this.direction = componentData.direction;
          this.params = JSON.parse(componentData.params);
        }
      }
    },
    methods: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lib/showMoudle/eleStep.vue